import { render } from "./BbaHealth.vue?vue&type=template&id=2c135fd6"
import script from "./BbaHealth.vue?vue&type=script&lang=js"
export * from "./BbaHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__